import { createRoute, Navigate } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { z } from 'zod';

export const settingsParentRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/settings',
}).lazy(() => import('./SettingsLayout').then((d) => d.Route));

const settingsIndexRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/',
  component: () => <Navigate to="/pharmacy/settings/profile" />,
});

const profileSettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/profile',
}).lazy(() => import('./pages/general/ProfileSettingsPage').then((d) => d.Route));

const pharmacySettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/pharmacy',
}).lazy(() => import('./pages/general/PharmacySettingsPage').then((d) => d.Route));

const bankingSettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/banking',
}).lazy(() => import('./pages/general/BankingSettingsPage').then((d) => d.Route));

const billingSettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/billing',
}).lazy(() => import('./pages/general/BillingSettingsPage').then((d) => d.Route));

const groupSettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/group',
}).lazy(() =>
  import('pages/pharmacy/Group/PharmacyGroupPage/PharmacyGroupPage').then((d) => d.Route)
);

const teamSettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/team',
}).lazy(() => import('./pages/general/TeamSettingsPage').then((d) => d.Route));

const konnectSettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/konnect',
  validateSearch: z.object({
    source: z.enum(['trades_banner']).optional(),
  }),
}).lazy(() =>
  import('pages/pharmacy/FaksKonnect/PharmacyFaksKonnectPage/PharmacyFaksKonnectPage').then(
    (d) => d.Route
  )
);

const kopilotSettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/kopilot',
}).lazy(() => import('./pages/feature/Kopilot/KopilotSettingsPage').then((d) => d.Route));

const extractorSettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/extractor',
}).lazy(() =>
  import(
    'pages/pharmacy/PanelistConnection/PharmacyPanelistConnectionPage/PharmacyPanelistConnectionPage'
  ).then((d) => d.Route)
);

const stripeSettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/stripe',
  validateSearch: z.object({
    compensationAmountInEuroCents: z.number().optional(),
    fromScreen: z.enum(['trade']).optional(),
  }),
}).lazy(() =>
  import('pages/pharmacy/Stripe/PharmacyStripePage/PharmacyStripePage').then((d) => d.Route)
);

const noteTemplatesSettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/note-templates',
}).lazy(() => import('./pages/feature/NoteTemplatesSettingsPage').then((d) => d.Route));

// Kept reachable for existing deep links (e.g. authorized-labs / stock cards);
// not surfaced in the settings sub-navigation.
const stockKonnectSettingsRoute = createRoute({
  getParentRoute: () => settingsParentRoute,
  path: '/stock-konnect',
}).lazy(() => import('./pages/feature/StockKonnectSettingsPage').then((d) => d.Route));

export const settingsRoute = settingsParentRoute.addChildren([
  settingsIndexRoute,
  profileSettingsRoute,
  pharmacySettingsRoute,
  bankingSettingsRoute,
  billingSettingsRoute,
  groupSettingsRoute,
  teamSettingsRoute,
  konnectSettingsRoute,
  kopilotSettingsRoute,
  extractorSettingsRoute,
  stripeSettingsRoute,
  noteTemplatesSettingsRoute,
  stockKonnectSettingsRoute,
]);
